/**
 * Merges an array of class names into a single string.
 *
 * @param classNames[] - An array of class names to be merged.
 * @returns A single string containing all class names separated by a space.
 */
export function mergeClassName(classNames: (string | undefined)[]): string {
  return classNames.filter(Boolean).join(' ');
}
